import type { FC, RefObject } from 'react';
import SearchResults from './SearchResults';
import type { FilterState } from '../../../types';
import type { Map } from 'ol';
import type { Cluster } from 'ol/source';
import type { Overlay } from 'ol';

interface SidebarProps {
  filters: FilterState;
  map: Map;
  clientSource: Cluster;
  vendorSource: Cluster;
  prospectSource: Cluster;
  popup: Overlay;
  popupRef: RefObject<HTMLDivElement>;
}

const Sidebar: FC<SidebarProps> = ({ 
  filters, 
  map, 
  clientSource,
  vendorSource,
  prospectSource,
  popup, 
  popupRef 
}) => {
  return (
      <SearchResults 
        filters={filters}
        map={map}
        clientSource={clientSource}
        vendorSource={vendorSource}
        prospectSource={prospectSource}
        popup={popup}
        popupRef={popupRef}
      />
  );
};

export default Sidebar;
